// extracted by mini-css-extract-plugin
module.exports = {"detailsSectionHeaderContainer":"styles_detailsSectionHeaderContainer__3_fsy","detailsSectionHeader":"styles_detailsSectionHeader__3US9d"};